import { combineReducers } from 'redux';
import { activeAuction } from 'components/active-auctions/reducer';
import { reducer as toastr } from 'react-redux-toastr';
import { myAuctions } from 'components/my-auctions/reducer';
import { manageAuction } from 'components/single-auction/reducer';
import { accounts } from 'components/accounts/reducers';
import { jewelListing } from 'components/jewel-listing/reducer';
import { jewelBid } from 'components/jewel-bid/reducer';
import { loading } from 'components/common/loaders/loading-reducer';
import { manageMedia } from 'components/single-auction/manage-media/reducer';
import { site } from './site-reducer';

export const rootReducer = combineReducers({
  site,
  activeAuction,
  myAuctions,
  jewelListing,
  manageMedia,
  manageAuction,
  jewelBid,
  loading,
  toastr,
  accounts
});
